import { observer } from 'mobx-react';
import * as React from 'react';
import { Task } from 'taskarian';
import { readVarT } from '../../Assertions/environments';
import { loadOneTrust } from './Loader';
import { handleOneTrustLoadError, OneTrustError } from './Types';

class OneTrustTooling extends React.Component {
  componentDidMount() {
    Task.succeed<OneTrustError, string>('VITE_ONE_TRUST_KEY')
      .andThen(readVarT)
      .andThen(loadOneTrust)
      .fork(handleOneTrustLoadError, () => {
        console.log('OneTrust Loaded Successfully!', window.OneTrust);
      });
  }

  render() {
    return <></>;
  }
}

export default observer(OneTrustTooling);
